import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';
import { LoaderService } from '../service/loader.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private totalRequests = 0;

  constructor(private loaderService: LoaderService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.headers.has('X-Skip-Loader')) {
      return next.handle(req);
    }

    if (this.totalRequests === 0) {
      this.loaderService.isLoading.next(true);
    }

    this.totalRequests++;

    return next.handle(req).pipe(
           finalize(() => {
        this.totalRequests--;
        if (this.totalRequests === 0) {
          this.loaderService.isLoading.next(false);
        }
      })
    );
  }
}
